import {
    FETCH_BLOGS,
    FETCH_BLOGS_SUCCESS,
    ADD_BLOG,
    ADD_BLOG_SUCCESS,
    ADD_BLOG_FAIL,
    UPDATE_BLOG,
    UPDATE_BLOG_SUCCESS,
    UPDATE_BLOG_FAIL,
    DELETE_BLOG,
    DELETE_BLOG_FAIL,
    DELETE_BLOG_SUCCESS,
    FETCH_BLOG_SUCCESS,
    FETCH_BLOG
} from '../actions/Blog';

const INITIAL_STATE = {
    blogs: {},
    isBlogLoading: false,
    errorMessage: ''
}

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_BLOGS:
            return { ...state, isBlogLoading: true };
        case FETCH_BLOGS_SUCCESS:
            return { ...state, isBlogLoading: false, blogs: action.payload };
        case FETCH_BLOG:
            return { ...state, isBlogLoading: true };
        case FETCH_BLOG_SUCCESS:
            const blogs = state.blogs;
            const updatedBlogs = { ...blogs, [action.payload.id]: action.payload.blog };
            return { ...state, isBlogLoading: false, blogs: updatedBlogs };
        
        case ADD_BLOG:
        case UPDATE_BLOG:
        case DELETE_BLOG:
            return { ...state, isBlogLoading: true, errorMessage: '' };
        case ADD_BLOG_SUCCESS:
        case UPDATE_BLOG_SUCCESS:
        case DELETE_BLOG_SUCCESS:
            return { ...state, isBlogLoading: false, errorMessage: '' };
        case ADD_BLOG_FAIL:
        case UPDATE_BLOG_FAIL:
        case DELETE_BLOG_FAIL:
            return { ...state, isBlogLoading: false, errorMessage: action.payload }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/BlogReducer.js